<template>
  <div>
    <v-layout row wrap>
      <v-flex>
        <aru-search-entity
          v-if="configReady"
          :with-progress-bar="true"
          :page="page"
          :search-config="config.search"
          :entity="entity"
          v-model="items"
          @loading="
            page = 1;
            itemsReady = false;
          "
          @stopLoading="itemsReady = true"
          @meta="setPagination"
        ></aru-search-entity>
      </v-flex>
    </v-layout>

    <v-list v-if="readyToList" two-line>
      <template v-for="entity in items">
        <v-list-tile :key="entity.id" avatar :to="'/notifications/' + entity.id">
          <v-list-tile-content>
            <v-list-tile-title>
              <h4 :class="{ 'grey--text': entity.readed }">{{ entity.title }}</h4>
            </v-list-tile-title>
            <v-list-tile-sub-title>
              <span class="mr-3 grey--text">
                <v-icon color="grey" size="14">mdi-calendar</v-icon>
                {{ entity.created_at | moment('DD/MM/YYYY') }}
              </span>
              {{ entity.body | truncate(400, '...') }}
            </v-list-tile-sub-title>
          </v-list-tile-content>
          <v-list-tile-action>
            <v-icon color="primary">mdi-chevron-right</v-icon>
            <!-- <img :src="entity.title"> -->
          </v-list-tile-action>
        </v-list-tile>
      </template>
    </v-list>

    <div class="text-xs-center" v-if="showPagination">
      <v-pagination v-model="page" :length="pagination.last_page"></v-pagination>
    </div>
  </div>
</template>

<script>
import apiCtrl from '@/services/aru-services/aru-api.service.js';
import AruListMixin from '@/mixins/list/AruListMixin.js';
import AruSearchEntity from '@/components/commons/search/AruSearchEntity';

export default {
  mixins: [AruListMixin],
  components: {
    AruSearchEntity,
  },
  data() {
    return {
      showForm: false,
      formData: {},
      header: [
        {
          value: 'title',
          text: 'Título',
          mockWidth: '300px',
        },
        {
          value: 'date',
          text: 'Fecha',
          mockWidth: '50px',
        },
        {
          value: 'time',
          text: 'Hora',
          mockWidth: '50px',
        },
        {
          value: 'group',
          text: 'Grupo',
          mockWidth: '100px',
        },
        {
          value: '',
          text: 'Acciones',
          btnClass: 'pr-4',
          thClass: 'text-xs-right py-0',
          mockAlign: 'right',
        },
      ],
    };
  },
  methods: {
    orderBy(field) {
      if (
        this.params.hasOwnProperty('orderBy') &&
        this.params.orderBy === field &&
        this.params.hasOwnProperty('sortedBy')
      ) {
        if (this.params.sortedBy === 'desc') {
          this.$set(this.params, 'orderBy', field);
          this.$set(this.params, 'sortedBy', 'asc');
        } else {
          delete this.params.orderBy;
          delete this.params.sortedBy;
        }
      } else {
        this.$set(this.params, 'orderBy', field);
        this.$set(this.params, 'sortedBy', 'desc');
      }

      this.getEntities();
    },
    editEntity(entity) {
      this.formData = entity;
      this.showForm = true;
    },
    deleteEntity(entity, i) {
      console.log({
        DELETE: entity,
      });

      apiCtrl.delete('/' + this.entity + '/' + entity.id).then(() => {
        this.getEntities();
      });
    },

    getOrderThColor(field) {
      if (this.params.hasOwnProperty('orderBy') && this.params.orderBy === field) {
        return 'primary';
      } else {
        return 'grey';
      }
    },
    getOrderChevronIcon(field) {
      if (
        this.params.hasOwnProperty('orderBy') &&
        this.params.orderBy === field &&
        this.params.hasOwnProperty('sortedBy')
      ) {
        if (this.params.sortedBy === 'asc') {
          return 'mdi-chevron-up';
        } else if (this.params.sortedBy === 'desc') {
          return 'mdi-chevron-down';
        }
      }

      return 'mdi-chevron-right';
    },
  },
};
</script>

<style lang="scss">
.v-btn-header-datatable {
  min-width: 0px;
  margin: 0px;
  padding: 0px;
}
</style>
